import ImgCom from "components/ImgCom"
import { ColumnCenter, Row } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled from "styled-components"

import daoSubmitImg from 'assets/images/dao_sumit.png'
import daoVoteImg from 'assets/images/dao_vote.png'
import { AddNewBtnLabelWrap, AddNewBtnWrap } from ".."

const ParticipateCom = () => {
    const openBrowser = (url: string) => {
        window.open(url, '_blank')
    }

    return <div>
        <StyledContainer $fontSize="18px" $lineHeight="18px" $fontWeight6>Participate in the DAO Ecosystem</StyledContainer>
        <StyledContainer $height="20px"></StyledContainer>
        <Row $justifyContent="space-between">
            <CardWrap>
                <ImgCom imgUrl={daoSubmitImg} width="110px" height="81px"></ImgCom>
                <StyledContainer $fontSize="16px" $lineHeight="1" $fontWeight6 $mt="30px" $mb="8px">Submit a proposal</StyledContainer>
                <StyledContainer $textAlign="center" $width="65%" $fontSize="14px" $lineHeight="18px" $fontWeight4 $color="#767A7F" $mb="25px">Submit proposals for internal review on the official Chainge DAO Telegram group</StyledContainer>

                <AddNewBtnWrap $alignSelf="center" onClick={() => openBrowser('https://t.me/ChaingeDAO')}>
                    <AddNewBtnLabelWrap $ml="0 !important" $roobertSemiBold>Submit now</AddNewBtnLabelWrap>
                </AddNewBtnWrap>
            </CardWrap>
            <CardWrap>
                <ImgCom imgUrl={daoVoteImg} width="110px" height="81px"></ImgCom>
                <StyledContainer $fontSize="16px" $lineHeight="1" $fontWeight6  $mt="30px" $mb="8px">Vote for a proposal</StyledContainer>
                <StyledContainer $textAlign="center" $width="65%"  $fontSize="14px" $lineHeight="18px" $fontWeight4 $color="#767A7F" $mb="25px">Vote for active ChaingeDAO proposals on the snapshot.org platform using vXCHNG tokens</StyledContainer>

                <AddNewBtnWrap $alignSelf="center" onClick={() => openBrowser('https://snapshot.org/#/chaingers.eth')}>
                    <AddNewBtnLabelWrap $ml="0 !important" $roobertSemiBold>Vote now</AddNewBtnLabelWrap>
                </AddNewBtnWrap>
            </CardWrap>
        </Row>
    </div>
}

const CardWrap = styled(ColumnCenter)`
    border-radius: 9px;
    border: 1px solid #F2F2F2;
    box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);
    width: 49%;
    padding: 30px;
    box-sizing:border-box;
`

export default ParticipateCom